import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { PharmacyProvider } from './context/PharmacyContext';

ReactDOM.render(
  <React.StrictMode>
    <PharmacyProvider>
      <App />
    </PharmacyProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
